/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/designFacePreview/model/designFacePreviewModel',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/designFacePreview/abstractRenderer',
        'assets/js/modules/designFacePreview/guideLines/view/rectangularView',
        'assets/js/modules/designFacePreview/guideLines/view/circleView',
        'assets/js/modules/designFacePreview/guideLines/view/presentationFolderView',
        'assets/js/modules/designFacePreview/guideLines/view/roundedView'
    ],
    function(
        $,
        _,
        DesignFacePreviewModel,
        AttributeModel,
        OptionModel,
        OptionValueModel,
        abstractRenderer,
        RectangularView,
        CircleView,
        PresentationFolderView,
        RoundedView
    ) {
        return _.extend({}, abstractRenderer, {
            selectorClassName: 'guide-lines',

            defaultOptions: {
                safeZone: {},
                bleedZone: {},
                trimZone: false
            },
            /**
             * @param {DesignFacePreviewModel} model
             * @param $target
             * @param {number} face
             */
            render: function(model, $target, face) {
                if (model.hasOptionValue(OptionModel.NAME_TRIMMING, OptionValueModel.NAME_NONE_TRIMMING)) {
                    this.destroy($target);
                    return;
                }

                if (model.get('width') === undefined) {
                    model.set('width', $target.width());
                }

                if (model.get('height') === undefined) {
                    model.set('height', $target.height());
                }

                var options = _.defaults(model.get('guideLinesOptions') || {}, this.defaultOptions);

                var view = this._createView(model, $target);

                if (options.bleedZone) {
                    view.renderBleedZone(options.bleedZone);
                }
                if (options.trimZone) {
                    view.renderTrimZone(options.trimZone);
                }
                if (options.safeZone) {
                    view.renderSafeZone(options.safeZone);
                }

                var foldingParams = this._getFoldingParams(model, face);
                view.renderFolding(foldingParams);

                if (view.hasLegendToRender()) {
                    view.renderLegend();
                }
            },

            _createView: function(model, $target) {
                var ViewClass = this._getViewClass(model);

                var $el = $target.find('.' + this.selectorClassName);

                if (!$el.length) {
                    $el = $('<canvas>').addClass(this.selectorClassName);
                    $target.prepend($el);
                }

                return new ViewClass({
                    model: model,
                    el: $el
                });
            },

            /**
             * @param {DesignFacePreviewModel} model
             * @returns {AbstractView}
             */
            _getViewClass: function(model) {
                var product = model.get('productSlug');
                if (product === 'pf') {
                    return PresentationFolderView;
                } else if (parseInt(model.get('shape')) === AttributeModel.VALUE_SHAPE_CIRCLE) {
                    return CircleView;
                } else if (model.hasOptionValue(OptionModel.NAME_CORNERS, OptionValueModel.NAME_ROUNDED_CORNERS)) {
                    return RoundedView;
                }

                return RectangularView;
            },

            /**
             * @param {DesignFacePreviewModel} model
             * @param {string} face
             * @returns {Object|null}
             */
            _getFoldingParams: function(model, face) {
                var params = null;
                var foldingType = model.get('options')[OptionModel.NAME_FOLDING];
                var foldingOptions = model.get('productPreviewInfo').get('folding') || {};
                var faceName =
                    face == DesignFacePreviewModel.PAGE.FRONT
                        ? DesignFacePreviewModel.FACE_NAMES.FRONT
                        : DesignFacePreviewModel.FACE_NAMES.BACK;

                if (foldingType) {
                    if (foldingOptions[foldingType] && foldingOptions[foldingType][faceName]) {
                        params = foldingOptions[foldingType][faceName];
                    }
                    if (!params && foldingType === OptionValueModel.NAME_Z_FOLD && foldingOptions[OptionValueModel.NAME_TRI_FOLD]) {
                        params = foldingOptions[OptionValueModel.NAME_TRI_FOLD][faceName] || {};
                    }
                }

                return params;
            }
        });
    }
);
